import _ from 'lodash';
import * as utils from '../common/client-utils-commonjs';
export function formatPregradingStatus(pregradingStatuses) {
    return pregradingStatuses.map(addExtraFields);
    function addExtraFields(pregradingStatus) {
        const teacherGradingProgress = gradingPercentage(pregradingStatus.answers, pregradingStatus.autogradedScores, pregradingStatus.pregradingScores);
        const teacherGradingFinishedProgress = gradingPercentage(pregradingStatus.answers, pregradingStatus.autogradedScores, pregradingStatus.pregradingFinishedCount);
        const eventDateStr = utils.finnishDateString(new Date(pregradingStatus.eventDate));
        return Object.assign(Object.assign({}, pregradingStatus), { teacherGradingProgress, teacherGradingCompleted: teacherGradingProgress === 100, eventDateStr,
            teacherGradingFinishedProgress });
    }
    function gradingPercentage(answerCount, autogradedScoresCount, manualScoresCount) {
        if (answerCount === 0 || answerCount === autogradedScoresCount) {
            return 100;
        }
        else {
            const percentage = Math.floor((manualScoresCount / (answerCount - autogradedScoresCount)) * 100);
            return percentage === 0 && manualScoresCount > 0 ? 1 : percentage;
        }
    }
}
export function formatGradingStatus(gradingStatuses) {
    return _.orderBy(gradingStatuses, ['eventDate', 'title', 'schoolAnonCode'], ['desc', 'asc', 'asc']).map(addExtraFields);
    function addExtraFields(gradingStatus) {
        const teacherGradingProgress = gradingPercentage(gradingStatus.answers, gradingStatus.autogradedScores, gradingStatus.pregradingScores);
        const teacherGradingFinishedProgress = gradingPercentage(gradingStatus.answers, gradingStatus.autogradedScores, gradingStatus.pregradingFinishedCount);
        const eventDateStr = utils.finnishDateString(new Date(gradingStatus.eventDate));
        return Object.assign(Object.assign({}, gradingStatus), { teacherGradingProgress, teacherGradingCompleted: teacherGradingFinishedProgress === 100, censorGradingCompleted: gradingStatus.censoringProgress === 100, eventDateStr,
            teacherGradingFinishedProgress });
    }
    function gradingPercentage(answerCount, autogradedScoresCount, manualScoresCount) {
        if (answerCount === 0 || answerCount === autogradedScoresCount) {
            return 100;
        }
        else {
            const percentage = Math.floor((manualScoresCount / (answerCount - autogradedScoresCount)) * 100);
            return percentage === 0 && manualScoresCount > 0 ? 1 : percentage;
        }
    }
}
//# sourceMappingURL=format-held-exams.js.map